<!--
  消息中心
  jay 2020-01-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.messageCenter')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <van-tabs
        v-model="active"
        @change="changeTab"
        title-active-color="#2042AB"
      >
        <van-tab
          :title="tab"
          v-for="(tab, tabIndex) in tabList"
          :key="tabIndex"
        >
          <div
            class="tab-scroll-box"
            :class="{ noCrad: !listData.length && getListFlag }"
          >
            <div v-if="!listData.length && getListFlag" class="noCard-wrap">
              <img src="@/assets/images/public/pic_kong@2x.png" />
              <p class="text-gray">{{ $t("common.noData") }}</p>
            </div>
            <scroll
              class="tab-scroll"
              ref="scroll"
              v-if="listData.length && getListFlag"
              :data="listData"
              :pullUpLoad="true"
              :pullDownRefresh="true"
              @pullingDown="pullingDown"
              @pullingUp="pullingUp"
            >
              <van-cell-group>
                <van-cell
                  :title="item.title"
                  :label="item.content"
                  is-link
                  v-for="(item, index) in listData"
                  :key="index"
                  @click="toDetail(item.id, index)"
                >
                  <span class="tab-title" slot="title">
                    <i class="point-icon" v-if="item.read_status == 0"></i>
                    {{ item.title }}
                  </span>
                </van-cell>
              </van-cell-group>
            </scroll>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <transition name="slide">
      <detail
        v-if="detailFlag"
        :detailFlag.sync="detailFlag"
        :data="detailData"
      />
    </transition>
  </div>
</template>

<script>
import Detail from "./detail";
export default {
  name: "notice",
  meta: {
    service: false // 客服
  },
  components: {
    Detail
  },
  data() {
    return {
      tabList: [
        this.$t("personal.personalMessage"),
        this.$t("personal.systemMessage")
      ],
      active: 0,
      listData: [],
      page: 1,
      getListFlag: false,
      detailFlag: false,
      id: "",
      detailData: {}
    };
  },
  created() {
    let type = this.$route.query.type;
    this.id = this.$route.query.id || "";
    this.active = type ? Number(type) : 0;
    this._getMessages();
    if (this.id) {
      this.toDetail(this.id);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    toDetail(id, index) {
      //详情
      let vm = this;
      let params = {};
      params.type = 3;
      params.id = id;
      vm.$post("/app/index/notice", params, { loading: true }).then(res => {
        console.log("notice", res);
        vm.detailData = res;
        vm.detailFlag = true;
        if (typeof index == "number") {
          vm.$set(vm.listData[index], "read_status", 1);
          console.log("listData", vm.listData);
        }
      });
    },
    changeTab() {
      this._getMessages();
    },
    pullingDown() {
      let vm = this;
      vm.page = 1;
      vm._getMessages();
    },
    pullingUp() {
      let vm = this;
      if (vm.pullUpLoadFlag) {
        for (let i = 0; i < vm.$refs.scroll.length; i++) {
          vm.$refs.scroll[i].forceUpdate(false);
        }
        return;
      }
      vm.page += 1;
      vm._getMessages(1);
    },
    _getMessages(flag) {
      let vm = this;
      let params = {};
      params.type = vm.active == 0 ? 2 : 1;
      params.page = vm.page;
      vm.getListFlag = false;
      let loading = true;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      vm.$post("/app/index/notice", params, { loading: loading }).then(res => {
        console.log("notice", res);
        if (vm.page == 1) {
          vm.listData = res;
        } else {
          vm.listData = vm.listData.concat(res);
        }
        if (res.length < 10) {
          vm.pullUpLoadFlag = true;
        } else {
          vm.pullUpLoadFlag = false;
        }
        vm.getListFlag = true;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-tabs__line {
  background: #2042ab;
}
/deep/.van-tabs {
  position: relative;
  height: 100%;
  width: 100%;
  .van-tabs__content {
    height: calc(100% - 44px);
  }
  .van-tab__pane,
  .tab-scroll-box {
    height: 100%;
  }

  .van-cell {
    display: flex;
    align-items: center;
    .tab-title {
      display: flex;
      align-items: center;
      .point-icon {
        width: 6px;
        height: 6px;
        border-radius: 6px;
        background: #fe7800;
        margin-right: 8px;
      }
    }
  }

  .van-cell__label {
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.tab-scroll {
  top: 44px !important;
}
</style>
